module.exports = __webpack_public_path__ + "static/img/2ziyuan1.dfa2be01.png";